// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2TAjp","requiredAsterisk":"Info_requiredAsterisk__3CkPv"};